import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Star, 
  BarChart3, 
  CreditCard, 
  MessageSquare, 
  Settings,
  Building2
} from 'lucide-react';

const Sidebar = ({ isOpen }) => {
  const menuItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', color: 'text-blue-600' },
    { path: '/providers', icon: Building2, label: 'Providers', color: 'text-green-600' },
    { path: '/reviews', icon: Star, label: 'Reviews', color: 'text-yellow-600' },
    { path: '/users', icon: Users, label: 'Users', color: 'text-purple-600' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics', color: 'text-indigo-600' },
    { path: '/payments', icon: CreditCard, label: 'Payments', color: 'text-emerald-600' },
    { path: '/chat', icon: MessageSquare, label: 'Chat', color: 'text-pink-600' },
    { path: '/settings', icon: Settings, label: 'Settings', color: 'text-gray-600' },
  ];

  return (
    <div className={`bg-white shadow-lg h-full transition-all duration-300 ${isOpen ? 'w-64' : 'w-16'}`}>
      {/* Logo */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center">
          <div className="h-8 w-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="h-5 w-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm8 0a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1V8zm0 4a1 1 0 011-1h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2z" clipRule="evenodd" />
            </svg>
          </div>
          {isOpen && (
            <div className="ml-3">
              <h1 className="text-lg font-bold text-gray-900">Admin Panel</h1>
              <p className="text-xs text-gray-500">ServiceFlow CZ</p>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-6">
        <div className="space-y-1 px-3">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-3 py-3 rounded-lg transition-colors group ${
                    isActive
                      ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`
                }
              >
                <Icon className={`h-5 w-5 flex-shrink-0 ${item.color}`} />
                {isOpen && <span className="ml-3 font-medium">{item.label}</span>}
              </NavLink>
            );
          })}
        </div>
      </nav>

      {/* Status Indicator */}
      {isOpen && (
        <div className="absolute bottom-4 left-4 right-4">
          <div className="bg-green-50 border border-green-200 rounded-lg p-3">
            <div className="flex items-center">
              <div className="h-2 w-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="ml-2 text-xs text-green-600 font-medium">System Online</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;